export enum Direction {
  NEXT = 'NEXT',
  PREVIOUS = 'PREVIOUS',
  FIRST = 'FIRST',
  LAST = 'LAST',
}
